import { OfflineBoltOutlined as OfflineBoltOutlinedIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import type { FunctionComponent } from 'react';

export const InaccessibleComponentAlert: FunctionComponent<{ readonly label: string }> = ({ label }) => (
    <Grid alignItems="center" container={true} gap={1}>
        <OfflineBoltOutlinedIcon fontSize="inherit" sx={{ height: '24px', width: '24px' }} />
        <Box>{label}</Box>
    </Grid>
);
